'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@repo/ui/lib/utils';
import { motion, Variants } from '@repo/ui/motion';
import { ComponentProps } from 'react';
const contentVariants: Variants = {
  hidden: {
    height: 0,
    opacity: 0,
    transition: {
      duration: 0.1,
      ease: 'easeInOut' as const
    }
  },
  visible: {
    height: 'auto',
    opacity: 1,
    transition: {
      duration: 0.3,
      ease: 'easeOut' as const,
      stiffness: 300
    }
  }
};
export const MotionCollapsibleContent = t0 => {
  const $ = _c(10);
  let children;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = cn("w-full", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== children || $[7] !== props || $[8] !== t1) {
    t2 = <motion.div animate="visible" className={t1} data-slot="collapsible-motion-content" exit="hidden" key="content" variants={contentVariants} {...props} data-sentry-element="motion.div" data-sentry-component="MotionCollapsibleContent" data-sentry-source-file="details-item-motion-content.tsx">{children}</motion.div>;
    $[6] = children;
    $[7] = props;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
};